import { render, staticRenderFns } from "./FormAnswers.vue?vue&type=template&id=0dbfbef4"
import script from "./FormAnswers.vue?vue&type=script&lang=js"
export * from "./FormAnswers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports